module.exports = require("eventemitter2");